import React from "react";
import { Link } from "react-router-dom";
import { CreditCard, Megaphone, Flag, Sticker, FileText, Layers, ChevronRight, Menu } from "lucide-react";
import { CATEGORIES } from "../data/mock";

const ICONS = { CreditCard, Megaphone, Flag, Sticker, FileText, Layers };

const CategorySidebar = () => {
  return (
    <aside className="w-full lg:w-72 shrink-0">
      <div className="bg-rose-500 text-white px-5 py-4 flex items-center gap-3 rounded-t-md">
        <Menu className="w-5 h-5" />
        <span className="font-bold text-sm tracking-wider uppercase">Shop By Categories</span>
      </div>
      <ul className="border border-zinc-200 border-t-0 rounded-b-md bg-white divide-y divide-zinc-100 overflow-hidden">
        {CATEGORIES.map((cat) => {
          const Icon = ICONS[cat.icon] || CreditCard;
          return (
            <li key={cat.slug}>
              <Link
                to={`/category/${cat.slug}`}
                className="flex items-center justify-between gap-3 px-5 py-3.5 text-sm font-medium text-zinc-800 hover:bg-rose-50 hover:text-rose-600 transition-colors group"
              >
                <div className="flex items-center gap-3">
                  <Icon className="w-4 h-4 text-zinc-400 group-hover:text-rose-500 transition-colors" />
                  <span className="uppercase tracking-wide text-xs">{cat.name}</span>
                </div>
                <ChevronRight className="w-4 h-4 text-zinc-300 group-hover:text-rose-500 transition-all group-hover:translate-x-0.5" />
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default CategorySidebar;
